import API from "../axios/API";

export const fetchPlans = (restaurantId) => {
  return async (dispatch, getState) => {
    let plansResponse;

    try {
      plansResponse = await API.get(
        `restaurants/${restaurantId}/default/plans`,
      );
    } catch (error) {
      plansResponse = error;
    }

    return plansResponse;
  };
};
